module.exports = __webpack_public_path__ + "static/leaves-875570cdda5008ba0c5ff1ff6ff1505a.jpg";